export enum VossPeriodEndAnchor {
    RoundedDownToNearestUnit = 0,
    FullLength = 1,
    RoundedUpToNearestUnit = 2,
}

export const VossPeriodEndAnchorText: Record<VossPeriodEndAnchor, string> = {
    [VossPeriodEndAnchor.RoundedDownToNearestUnit]: 'vossPeriodEndAnchor.roundedDownToNearestUnit',
    [VossPeriodEndAnchor.FullLength]: 'vossPeriodEndAnchor.fullLength',
    [VossPeriodEndAnchor.RoundedUpToNearestUnit]: 'vossPeriodEndAnchor.roundedUpToNearestUnit',
};

export const periodEndAnchors = Object.keys(VossPeriodEndAnchorText).map(Number) as VossPeriodEndAnchor[];

export enum VossPlanChangeBehaviour {
    RetainInitialPeriodDates = 0,
    RecalculatePeriodDates = 1,
}

export const VossPlanChangeBehaviourText: Record<VossPlanChangeBehaviour, string> = {
    [VossPlanChangeBehaviour.RetainInitialPeriodDates]: 'vossPlanChangeBehaviour.retainInitialPeriodDates',
    [VossPlanChangeBehaviour.RecalculatePeriodDates]: 'vossPlanChangeBehaviour.recalculatePeriodDates',
};

export const planChangeBehaviours = Object.keys(VossPlanChangeBehaviourText).map(Number) as VossPlanChangeBehaviour[];

export enum VossBindingPeriodEndAction {
    Renew = 0,
    Terminate = 1,
}

export const VossBindingPeriodEndActionText: Record<VossBindingPeriodEndAction, string> = {
    [VossBindingPeriodEndAction.Renew]: 'vossBindingPeriodEndAction.renew',
    [VossBindingPeriodEndAction.Terminate]: 'vossBindingPeriodEndAction.terminate',
};

export const bindingPeriodEndActions = Object.keys(VossBindingPeriodEndActionText).map(Number) as VossBindingPeriodEndAction[];

export enum VossPeriodOffsetAnchor {
    PeriodCreated = 0,
    PeriodStart = 1,
    PeriodEnd = 2,
}

export const VossPeriodOffsetAnchorText: Record<VossPeriodOffsetAnchor, string> = {
    [VossPeriodOffsetAnchor.PeriodCreated]: 'vossPeriodOffsetAnchor.periodCreated',
    [VossPeriodOffsetAnchor.PeriodStart]: 'vossPeriodOffsetAnchor.periodStart',
    [VossPeriodOffsetAnchor.PeriodEnd]: 'vossPeriodOffsetAnchor.periodEnd',
};

export const periodOffsetAnchors = Object.keys(VossPeriodOffsetAnchorText).map(Number) as VossPeriodOffsetAnchor[];
